import React from 'react';
import classnames from 'classnames';
import spinner from '../../assets/spinner.gif';
import styles from './styles.module.scss';

const Spinner = ({customClassNames = {}}) => (
  <div className={classnames(styles.spinnerContainer, customClassNames)}>
    <img src={spinner} alt="spinner" className={styles.spinner}/>
  </div>
);

export default Spinner;
